import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import MemberEmailPreferenceList from './email-preference-list';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = { message: null };

        if (!props.lists) {
            props.getLists();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.message != this.state.message) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.lists != this.props.lists) {
            return true;
        }

        if (nextProps.dirty != this.props.dirty) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        return false;
    }

    render({ submitting, lists, dirty }) {
        const button_class = dirty && !submitting ? 'button-warning' : 'button-warning disabled';
        const button_text = submitting ? 'submitting…' : 'save settings';

        if (lists) {
            return (
                <member-email-preferences>
                    <form>
                        {lists.map((list, index) => this.renderList(list, index))}
                        <div className='has-text-center'>
                            {this.renderMessage()}
                            <button
                                className={button_class}
                                onClick={(e) => this.saveSettings(e)}
                                disabled={submitting}
                            >{button_text}</button>
                        </div>
                    </form>
                </member-email-preferences>
            );
        }

        return (<member-email-preferences />);
    }

    renderList(list, index) {
        return (<MemberEmailPreferenceList code={list.code} index={index} />);
    }

    renderMessage() {
        if (this.props.error && !this.props.dirty) {
            return (
                <p className='form-message'>
                    Unable to save one or more of your preferences.
                    ({this.props.error})
                </p>
            );
        } else if (this.state.message && !this.props.submitting) {
            return (<p className='form-message'>{this.state.message}</p>);
        }

        return (<p className='form-message'>&nbsp;</p>);
    }

    saveSettings(e) {
        e.preventDefault();

        if (!this.props.submitting) {
            if (!this.props.dirty) {
                this.setState({
                    message: 'Please select an email to subscribe or unsubscribe to above.',
                });
            } else {
                this.props.saveLists();
                this.setState({
                    message: 'You have successfully updated your email preferences. Please allow up to 48 hours for ' +
                        'this to take effect.',
                });
            }
        }
    }
}

const mapStateToProps = (state) => ({
    submitting: state['mail-lists'] && state['mail-lists'].submitting,
    lists: state['mail-lists'] && state['mail-lists'].lists,
    error: state['mail-lists'] && state['mail-lists'].error,
    dirty: state['mail-lists'] && state['mail-lists'].dirty,
});

const mapDispatchToProps = (dispatch) => ({
    saveLists: () => dispatch({ type: 'mail-lists:save' }),
    getLists: () => dispatch({ type: 'mail-lists:get' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


